import { render, staticRenderFns } from "./FooterSP.vue?vue&type=template&id=1b31aa95"
import script from "./FooterSP.vue?vue&type=script&lang=js"
export * from "./FooterSP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports